import React, {useState, useEffect} from 'react';
import ic_close from 'image/icon/ic_close_b.svg'
import {BtnIcon} from 'components/btns'
import {InputText, InputTextArea, InputMultiImages, InputTel, InputEmail, InputPw} from 'admin/components';
import {alertDone} from 'function/alert';
import {inputPhoneNumber} from 'function/telPattern';
// firebase
import firebase  from 'library/firebase-config.js'
import 'firebase/firestore';
import 'firebase/storage';
const db = firebase.firestore();
const storage = firebase.storage();
const COLLECTION = 'customer_qna';

const FORMINIT = {
  title: "",
  text: "",
  email: "",
  contact: "",
  name: "", 
  password: '',
  images : [],
  comment: [],
}

const WriteQna = (props) => {
  const [nowForm, setNowForm] = useState(FORMINIT);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [imageLabel, setImageLabel] = useState('파일 첨부');
  const [imageFile, setImageFile] = useState([]);

  useEffect(() => {
    if(isImageLoading){
      setImageLabel('업로드 중...')
    }else{
      setImageLabel('파일 첨부')
    }
  }, [isImageLoading])

  const handleCloseClicked = () => {
    setNowForm(FORMINIT);
    props.setWriteQna(false);
    setImageFile([])
  }

  const handleTextChange = (e) => {
    if(e.target.type === "tel"){
      inputPhoneNumber(e.target)
    }
    setNowForm({
      ...nowForm,
      [e.target.name] : e.target.value
    })

  }
  const handleFileChange = async (e) => {
    if(e.target.files&&e.target.files[0]){
      setIsImageLoading(true)

      const file = e.target.files[0];
      const fileName = file.name;
      setImageFile([...imageFile, file]);

      const reader = new FileReader();
      reader.onload =  (e) =>  {
        setNowForm({
          ...nowForm,
          images: [
            ...nowForm.images,
            {
              imageUrl: e.target.result,
              imageName: fileName,
            }
          ]
        });
      };
      reader.readAsDataURL(e.target.files[0]);
      
      setIsImageLoading(false)
    }
  }
  const handleDeleteImageClick = (img) => {
		setNowForm({
			...nowForm,
			images : nowForm.files.filter(el => {
				return el !== img;
			})
    })
  } 
  
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    props.setIsLoading(true);
    const url = await Promise.all(
      imageFile.map(img => {
        return fbUploadStorage( mkdir(nowForm),img)
      })
    )

    const newForm = {...nowForm};
    newForm.images.forEach((img,index) => {
      img.imageUrl = url[index];
      img.rootPath = `${mkdir(nowForm)}/${img.imageName}`
    })

    await fbUploadDb(COLLECTION, newForm);
    initForm();
    props.setIsLoading(false);
    alertDone();
  }

  

  // fireabse
  const fbUploadDb = async (col, form) => {
    try{
      const date = new Date();

      const newForm = {
        ...form,
        uploadDate: `${date.getFullYear()}.${date.getMonth()+1}.${date.getDate()}`,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      }
      const ref = await db.collection(col).add(newForm);

      props.setData([{
        ...newForm,
        id: ref.id,
      },...props.data, ])
    }
    catch(err){
      console.log(err)
    }
  }

  const fbUploadStorage = async (root, file)=> {
    const ref = storage.ref(`${root}/${file.name}`);
    await ref.put(file);
    return ref.getDownloadURL();
  }

  const mkdir = (form) => {
    return `${COLLECTION}/${form.name}/${form.title}`
  }

  const initForm = () => {
    setNowForm(FORMINIT);
    props.setWriteQna(false);
  }

  return (
    <section className={`WriteQna ${props.writeQna ? `active` :''}`}>
      <div className="con">
      <div className="write-header">
        <div className="con">
          <h4 className="title">질문 하기</h4>
          <BtnIcon className="btn-close" image = {ic_close} onClick = {handleCloseClicked}/>
        </div>
      </div>

      <div className="write-body">
        <div className="con">
          <form action="" className="form-write" onSubmit={handleFormSubmit}>
            <InputText label="제목" onChange={handleTextChange} name="title" value={nowForm.title} placeholder = "제목" required = {true}/>
            <InputText label="이름/업체" onChange={handleTextChange} name="name" value={nowForm.name} placeholder = "이름/업체명"  required = {true}/>
            <InputEmail label="이메일" onChange={handleTextChange} name="email" value={nowForm.email} placeholder = "이메일" required = {true}/>
            <InputTel label="연락처" onChange={handleTextChange} name="contact" value={nowForm.contact} placeholder = "연락처"  required = {true}/>
            <InputTextArea label = "내용" onChange={handleTextChange} name = "text" value = {nowForm.text} placeholder="내용"  required = {true}/>
            <InputMultiImages label = "첨부파일" imageLabel = {imageLabel} onChange = {handleFileChange} name ="files" placeholder = "파일 첨부" images = {nowForm.images} handleDeleteImageClick = {handleDeleteImageClick}/>
            <InputPw label="비밀번호" onChange={handleTextChange} name="password" value={nowForm.password} placeholder = "비밀번호"  required = {true}/>
            
            <input type="submit" className="form-submit" value = "저장"/>

          </form>
        </div>
      </div>
      </div>
    </section>
  );
}

export default WriteQna;